export enum GtmEvents {
    'AuthenticationSuccess' = 'Authentication success',
    'AuthenticationFailed' = 'Authentication failed',
    'SigningSuccess' = 'Signing success',
    'SigningFailed' = 'Signing failed',
    'ConsentSuccess' = 'Consent success',
    'ConsentFailed' = 'Consent failed'
};